export enum DateTransformOptions {
  CurrentDate = 'CurrentDate',
  ToTheEndOfMonth = 'ToTheEndOfMonth',
  OneCalendarMonth = 'OneCalendarMonth',
}
